<template>
  <div class="rows_per_page">
    <span class="rows_per_page_text">{{ text }}</span>
    <Dropdown
      fontWeightRegular
      compact
      placeholder=""
      v-model="paginationSize"
      :options="paginationSizeOptions"
    />
  </div>
</template>

<script>
import Dropdown from "./Inputs/Dropdown.vue";

export default {
  name: "RowsPerPage",
  components: {
    Dropdown,
  },
  props: {
    text: {
      type: String,
      default: "Rows per page",
    },
    paginationSizeOptions: {
      type: Array,
      default: () => [
        { value: 10, displayValue: "10" },
        { value: 25, displayValue: "25" },
        { value: 50, displayValue: "50" },
        { value: 100, displayValue: "100" },
      ],
    },
    defaultPaginationSize: {
      type: Number,
      default: 10,
    },
  },
  watch: {
    paginationSize() {
      this.$emit("onPaginationSizeChange", this.paginationSize);
    },
  },
  data() {
    return {
      paginationSize: this.defaultPaginationSize,
    };
  },
};
</script>

<style lang="scss">
@import "~include-media";

.rows_per_page {
  display: flex;
  .rows_per_page_text {
    margin-right: 15px;
    align-self: center;
    @include media("<tablet") {
      display: none;
    }
  }
}
</style>
